/**
 * Engine time source.
 *
 * Everything time-dependent (log timestamps, frame deltas, idle timeouts,
 * boot minimum display time) reads time through this interface so tests can
 * drive it deterministically with `ManualClock`.
 */
export interface Clock {
  /** Milliseconds on a monotonic timeline (like `performance.now()`). */
  now(): number;
  /** Seconds elapsed since the clock was created: the Output Log's `[0.047]` stamp. */
  sinceStart(): number;
}

/** The real clock, backed by `performance.now()`. */
export class SystemClock implements Clock {
  private readonly startMs: number;

  constructor(startMs: number = performance.now()) {
    this.startMs = startMs;
  }

  now(): number {
    return performance.now();
  }

  sinceStart(): number {
    return (performance.now() - this.startMs) / 1000;
  }
}
